import request from '@/config/axios'
import type { PageParam } from '@/types/common'
import type { PageResult } from '@/api/lawyer'

export interface FirmNoticeVO {
  id?: number
  title: string
  content: string
  scopeType: string
  scopeId?: number
  scopeName?: string
  status?: string
  publishTime?: string
  publisherUserId?: number
  remark?: string
  readFlag?: boolean
  readCount?: number
  createTime?: string
}

export interface FirmNoticePageReq extends PageParam {
  title?: string
  status?: string
  scopeType?: string
  inboxOnly?: boolean
}

export const FirmNoticeApi = {
  create: (data: FirmNoticeVO) =>
    request.post({ url: '/lawyer/firm/admin/notice/create', data }),
  update: (data: FirmNoticeVO) =>
    request.put({ url: '/lawyer/firm/admin/notice/update', data }),
  delete: (id: number) =>
    request.delete({ url: '/lawyer/firm/admin/notice/delete?id=' + id }),
  get: (id: number) =>
    request.get<FirmNoticeVO>({ url: '/lawyer/firm/admin/notice/get?id=' + id }),
  page: (params: FirmNoticePageReq) =>
    request.get<PageResult<FirmNoticeVO>>({ url: '/lawyer/firm/admin/notice/page', params }),
  publish: (id: number) =>
    request.put({ url: '/lawyer/firm/admin/notice/publish?id=' + id }),
  archive: (id: number) =>
    request.put({ url: '/lawyer/firm/admin/notice/archive?id=' + id }),
  read: (id: number) =>
    request.put({ url: '/lawyer/firm/admin/notice/read?id=' + id })
}

export const NOTICE_STATUS_OPTIONS = [
  { value: 'DRAFT', label: '草稿' },
  { value: 'PUBLISHED', label: '已发布' },
  { value: 'ARCHIVED', label: '已下架' }
]

export const NOTICE_SCOPE_OPTIONS = [
  { value: 'ALL', label: '全所' },
  { value: 'ORG_UNIT', label: '指定组织' },
  { value: 'TEAM', label: '指定团队' }
]

export const noticeStatusLabel = (status?: string) =>
  NOTICE_STATUS_OPTIONS.find((o) => o.value === status)?.label || status || '-'

export const noticeScopeLabel = (scopeType?: string) =>
  NOTICE_SCOPE_OPTIONS.find((o) => o.value === scopeType)?.label || scopeType || '-'
